<template>
  <generic-in-app-screen>
    <div>
      <!--       <confirm-leave-dialog
        ref="modal_unsaved_changes"
        :text_unsaved_changes="$t('text_unsaved_changes')"
      /> -->
      <div v-show="can_show">
        <b-container>
          <h1 class="mt-5">
            <div>
              <div ref="symbolholder" :class="symbolholderclasses()">
                <div class="presymbol">
                  <span :class="presymbolclasses()" />
                </div>
                <div class="symbol"><span :class="symbolclasses()" /></div>
              </div>

              <b> {{ msg }} </b>

              <metavariables-selector
                v-model="selected_metavariables_dicts_poids"
                :computation_time="computation_time"
                :available_metavariables_dicts="available_metavariables_dicts"
                :failed_metavariables_dicts="failed_metavariables_dicts"
                @recompute="recompute_metavariables_dict($event)"
                class="float-right"
              />
            </div>
          </h1>

          <description-edition
            ref="description_edition"
            v-model="description_name"
          />
          <b-alert
            v-for="semantic_warning in brick_semantic_warnings"
            :key="JSON.stringify(semantic_warning)"
            show
            variant="info"
          >
            {{ $t(semantic_warning) }}</b-alert
          >
          <b-alert
            v-for="warning in brick_runtime_warnings"
            :key="JSON.stringify(warning)"
            show
            variant="info"
          >
            {{ $t(warning[0], warning[1]) }}
          </b-alert>

          <b-alert
            v-for="exception in semantic_and_runtime_exceptions"
            :key="JSON.stringify(exception.msg)"
            show
            :variant="exception.variant"
          >
            {{
              exception.is_translatable
                ? $t(exception.msg[0], exception.msg[1])
                : exception.msg
            }}
          </b-alert>
          <b-progress
            class="my-4"
            :variant="progress_percentage !== 100 ? 'primary' : 'success'"
            show-progress
            :animated="progress_percentage !== 100"
          >
            <b-progress-bar :value="progress_percentage">
              {{ (progress_percentage || 0).toFixed(1) }} %
            </b-progress-bar>
          </b-progress>
        </b-container>

        <div class="my-4">
          <unroll-element
            v-for="(poid, index) in selected_metavariables_dicts_poids"
            :title="element_preview_title(poid)"
            :available="
              selected_metavariables_dicts_poids_instantiation_status[index]
            "
            :failed="partially_failed_poids.indexOf(poid) !== -1"
            :all_screen="true"
            :already_in_container="false"
            @toggled_visibility="toggled_table_visibility(index, $event)"
          >
            <div v-if="tables_previews_visibility[index]">
              <component
                :is="element_preview_type"
                :project_id="project_id"
                :poid="poid"
                class="synaplus-cosmo-h-720"
              />
            </div>
          </unroll-element>
        </div>

        <component
          :is="current_component_name"
          ref="component"
          :project_id="project_id"
          :brick_id="brick_id"
          :description_name="description_name"
          :metavariables_dicts_poids="selected_metavariables_dicts_poids"
          @save_description_edition="on_save_description_edition"
          @update_has_unsaved_changes="update_has_unsaved_changes"
        />

        <b-container>
          <validation-buttons-bar
            ref="validation_buttons_bar"
            :saved="!has_unsaved_changes"
            :disabled_edition="changes_disabled"
            :is_validating="is_validating"
            @cancel="cancel"
            @save="save"
            @validate="validate"
          />
        </b-container>
      </div>

      <b-container v-show="!can_show">
        <h1>{{ $t('loading_component') }}</h1>
        <div
          class="container flex-row h-100 spinner justify-content-center align-items-center d-flex"
        >
          <scale-loader
            :loading="scale_loader_properties.loading"
            :color="scale_loader_properties.color"
            :height="scale_loader_properties.height"
            :width="scale_loader_properties.width"
          />
        </div>
      </b-container>
    </div>
  </generic-in-app-screen>
</template>

<style lang="scss" scoped>
@import '@/custom-bootstrap.scss';

// TODO: implement https://codepen.io/anon/pen/pmbOgm

.brickeditionsymbolholderdefault {
  position: relative;

  top: #{-2 * $offset}px;
  left: #{-2 * $offset}px;
  height: #{3 * $base-size + 2 * $dash-line-size}px;
  width: #{3 * $base-size + 2 * $dash-line-size}px;

  font-size: #{3 * $base-size}px;
  line-height: #{3 * $base-size}px;
  padding: #{$dash-line-size}px;
}
</style>

<i18n>
{
  "en": {
    "loading_component": "Loading component",
    "used_tables": "Used tables",
    "please_choose_a_metavariables_dict": "Please choose a dictionary of metavariables (Current: {md} for poid: {poid})",
    "cwsx_too_many_input_tables": "Multiple input tables have been connected to this brick though it can only accept one",
    "cwsx_no_file_selected": "No file selected",
    "cwsx_no_input_table": "No input table connected",
    "cwsx_no_valid_input": "All input bricks are incomplete / erroneous",
    "cwsx_no_target_column_chosen": "No target column chosen",
    "cwsx_nb_cross_validation_folds_too_small": "The number of cross validation folds is too small (must at least be 2)",
    "cwrx_invalid_target_less_than_two": "The chosen target has less than 2 distinct values",
    "cwrx_invalid_target_more_than_two": "The chosen target has more than 2 distinct values",
    "cwrx_invalid_target_not_found": "The chosen target could not be found in parent table",
    "cwsx_no_junction_table_chosen": "No junction table chosen",
    "cwsx_cannot_find_junction_table": "The junction table given was not found among parent tables",
    "cwrx_no_results_columns": "You have not chosen any columns, or they are not present in the parent table",
    "cwsx_empty_colname": "The name of the column is empty",
    "cwsw_incorrect_dispatch": "The dispatch brick must contain one training table and optionally one evaluation table",
    "cwsx_no_separator": "No separator chosen",
    "cwsx_no_scorer_chosen": "No scorer chosen",
    "cwsx_threshold_not_integer": "Threshold should be an integer",
    "cwsx_nb_single_cv_not_integer": "Number of iterations to estimate models performance should be an integer",
    "cwsx_nb_full_cv_not_integer": "Number of iterations for robust estimation of best found models should be an integer",
    "cwsx_nb_caruana_iters_not_integer": "Number of iterations to search for best model should be an integer",
    "cwsx_nb_single_cv_asked_fold_not_integer": "Choice of default robust test should be an integer",
    "cwsx_nb_folds_not_integer": "Number of robust tests should be an integer",
    "cwsx_cv_seed_not_integer": "Cross validation seed should be an integer",
    "cwsx_nb_boruta_iterations_not_integer": "Number of feature importance tests should be an integer",
    "cwsx_boruta_perc_not_integer": "Confidence percentage for importance tests should be an integer",
    "cwsx_boruta_alpha_not_integer": "Alpha parameter for boruta should be an integer",
    "cwsx_no_models_chosen": "No models has been chosen",
    "cwsx_incorrect_file_type": "The uploaded file must be either a .csv or a .zip containing a .csv",
    "cwrx_codec_failed": "The selected file encoding is not able to read the uploaded file",
    "cwsx_no_separator": "No separator chosen",
    "cwrx_invalid_string_maxchars": "One string column has a value entered in the Maximal number of characters per string which is not an integer",
    "cwsx_no_period_id_column": "You must choose a column of period id",
    "cwsx_no_index_columns": "You must choose at least one index column",
    "cwsx_empty_filter_formula": "The filter formula must be completed",
    "cwrx_invalid_filter_formula_type": "The filter formula expression is invalid",
    "cwsx_different_nb_rows_tables": "The tables in entry haven't all the same number of rows",
    "cwrx_invalid_number": "The value entered for the constant number column is invalid",
    "cwrx_invalid_string": "The value entered for the constant text column is invalid",
    "cwsx_no_primary_key": "You must chose primary key cols",
    "cwrx_invalid_number": "The number chosen is invalid",
    "cwsx_history_start_not_integer": "The history start must be an integer",
    "cwsx_history_stop_not_integer": "The history stop must be an integer",
    "cwrx_unicity_col_not_present": "One of the unicity cols you enter is not present in the parent table",
    "cwrx_discriminating_col_not_present": "One of the discriminating cols you enter is not present in the parent table",
    "cwsx_parent_not_history_table": "The parent table should be a history table",
    "cwsx_filename_has_incorrect_characters": "The filename chosen contains invalid characters ('/' or '\\' for example)",
    "cwsx_empty_filename": "The filename chosen can't be empty",
    "cwsx_relation_table_not_found": "One of the table described in the relations has not been found",
    "cwrx_period_id_not_valid": "The periodicity column chosen doesn't seem to be at the correct format",
    "cwsx_no_column_selected": "You didn't select any column",
    "cwrx_invalid_date_format": "The date input does not respect the required format",
    "cwrx_cannot_convert_to_date": "The date input is not a correct date",
    "cwrx_index_column_not_present": "One of the index column could not be found in one of the table",
    "cwrx_invalid_index": "The chosen index columns doesn't constitute a real index beacause of values duplication",
    "cwrx_period_id_column_not_present": "The period_id column could not be found in one of the table",
    "cwrx_period_id_present_in_multiple_tables": "A period_id cannot be present in more than one table",
    "cwrx_too_high_index_in_filter": "An index in the filter is higher than the number of rows of parent table",
    "cwrx_negative_index_in_filter": "An index of the filter is negative",
    "cwrx_datetime_periodicity_col": "The periodicity column must be a number at the YYYYMM format and not a Datetime column",
    "cwrx_fe_different_size": "The value for the new column has not the same size as the entry table",
    "cwsx_duplicate_colname": "More than one column having the same name have been created",
    "cwrx_fe_invalid_formula": "The formula entered for one the column is invalid",
    "cwrx_fe_invalid_type": "The type of the result of one of the formula is not accepted. Only numeric, datetime or strings types are accepted by Cosmo",
    "cwrx_column_only_header": "One of the column seems to have no data (only the header seems present)",
    "cwsx_start_ref_not_integer": "The reference period start must be an integer",
    "cwsx_stop_ref_not_integer": "The reference period stop must be an integer",
    "cwsx_start_comp_not_integer": "The comparison period start must be an integer",
    "cwsx_stop_comp_not_integer": "The comparison period stop must be an integer",
    "cwsx_no_table_satisfying_metavariable_conditions": "No table could fit the metavariables dict {required_metavariables} condition. This warning can be ignored if present in a partially configured Dispatch brick",
    "cwsx_no_file_satisfying_metavariable_conditions": "No file could fit the metavariables dict {required_metavariables} condition. This warning can be ignored if present in a partially configured File brick",
    "cwrx_invalid_expression": "The expression {expression} is incorrect",
    "cwsx_start_stop_incoherent": "The start value given is greater than the stop value",
    "cwsx_no_column_created": "No new columns have been created",
    "cwrx_ast_eval_error": "Error encountered in the code evaluator : '{error_message}'",
    "cwrw_column_name_overridden": "The following columns are initially present in the entry table, so their values will be replaced : {overridden_colnames}",
    "cwsw_start_greater_stop": "The history start is greater than the history stop",
    "cwrw_columns_not_found": "Some of the selected columns are not present in the file",
    "cwsw_duplicates_new_names": "Some of the new names given for columns to rename or to copy are the same, so these columns will be overwritten",
    "cwsx_no_dsn": "Missing DSN",
    "cwsx_no_query_string": "SQL Query string empty",
    "cwsx_invalid_batch_size": "Batch size must be a positive number",
    "cwsw_start_ref_greater_stop_ref": "The history reference start is greater than the history reference stop",
    "cwsw_ref_empty": "Input reference period is empty",
    "cwsw_start_comp_greater_stop_comp": "The history comparison start is greater than the history comparison stop",
    "cwsw_comp_empty": "Input comparison period is empty",
    "cwrx_apply_input_coercion": "Error in Table to Json transformation",
    "cwrx_apply_output_coercion": "Error in Json to Table transformation",
    "cwrx_apply_select_field": "Error in 'Select a field' operation",
    "cwrx_apply_insert_in_field": "Error in 'Insert in a field' operation",
    "cwrx_apply_object_to_table": "Error in 'Transform to array if object' operation",
    "cwrx_apply_table_to_object": "Error in 'Transform array to object if it has a unique observation' operation",
    "cwrx_invalid_manual_json": "Invalid manually defined Json",
    "cwxs_input_not_dict": "The entered formula must be a dict",
    "cwrw_column_distribution_has_changed": "The \"{column_name}\" column distribution has changed",
    "cwsx_unknwown_database_name": "The database \"{database_name}\" doesn't exist",
    "cwsx_database_name_has_duplicated": "Multiple databases have the name \"{database_name}\""

  },
  "fr": {
    "loading_component": "Composant en chargement",
    "used_tables": "Tables utilisées",
    "please_choose_a_metavariables_dict": "Choisissez le jeu de metavariables à afficher (Actuel: {md} pour le poid: {pid})",
    "cwsx_too_many_input_tables": "Ce composant possède plusieurs tables d'entrée alors qu'il est censé n'en avoir qu'une",
    "cwsx_no_file_selected": "Aucun fichier sélectionné",
    "cwsx_no_input_table": "Aucune table connectée en entrée",
    "cwsx_no_valid_input": "Toutes les briques en entrée sont ou incomplètes ou erronnées",
    "cwsx_no_target_column_chosen": "Aucune colonne cible choisie",
    "cwsx_nb_cross_validation_folds_too_small": "Le nombre de folds de validation croisée est trop petit (doit être au moins égal à 2)",
    "cwrx_invalid_target_less_than_two": "La cible choisie a moins de 2 valeurs distinctes",
    "cwrx_invalid_target_more_than_two": "La cible choisie a plus de 2 valeurs distinctes",
    "cwrx_invalid_target_not_found": "La cible choisie n'a pas été trouvée dans la table parent",
    "cwsx_no_junction_table_chosen": "La table de jointure n'a pas été choisie",
    "cwsx_cannot_find_junction_table": "La table de jointure choisie n'a pas été trouvée parmi les tables parentes",
    "cwrx_no_results_columns": "Vous n'avez pas choisi de colonnes, ou elles ne sont pas présentes dans la table parent",
    "cwsx_empty_colname": "Le nom de la colonne choisie est vide",
    "cwsw_incorrect_dispatch": "La brique dispatch doit contenir une table d'entraînement et optionellement une table d'évaluation",
    "cwsx_no_separator": "Aucun séparateur n'a été choisi",
    "cwsx_no_scorer_chosen": "Aucun scoreur n'a été choisi",
    "cwsx_threshold_not_integer": "Le seuil choisi doit être un entier",
    "cwsx_nb_single_cv_not_integer": "Le nombre d'itérations d'estimation de la performance de modèles doit être un entier",
    "cwsx_nb_full_cv_not_integer": "Le nombre d'itérations du test de robustesse des meilleurs modèles trouvés doit être un entier",
    "cwsx_nb_caruana_iters_not_integer": "Le nombre d'itérations de recherche du meilleur modèle doit être un entier",
    "cwsx_nb_single_cv_asked_fold_not_integer": "Le choix du test de robustesse par défaut doit être un entier",
    "cwsx_nb_folds_not_integer": "Le nombre de tests de robustesse doit être un entier",
    "cwsx_cv_seed_not_integer": "La seed de validation croisée doit être un entier",
    "cwsx_nb_boruta_iterations_not_integer": "Le nombre de tests d'importance des features doit être un entier",
    "cwsx_boruta_perc_not_integer": "Le pourcentage de confiance pour les tests d'importance doit être un entier",
    "cwsx_boruta_alpha_not_integer": "Le paramètre Alpha de Boruta doit être un entier",
    "cwsx_no_models_chosen": "Aucun modèle n'a été sélectionné.",
    "cwsx_incorrect_file_type": "Le fichier uploadé doit être un .csv ou un .zip contenant un .csv",
    "cwrx_codec_failed": "L'encoding sélectionné ne permet pas de lire le fichier choisi",
    "cwsx_no_separator": "Aucun séparateur n'a été choisi",
    "cwrx_invalid_string_maxchars": "Une des colonnes de texte a la valeur entrée pour le champ Nombre maximal de caractères par chaîne qui n'est pas un nombre entier",
    "cwsx_no_period_id_column": "Vous devez choisir une colonne de période (period_id)",
    "cwsx_no_index_columns": "Vous devez choisir la ou les colonnes d'index",
    "cwsx_empty_filter_formula": "La formule du filtre doit être renseignée",
    "cwrx_invalid_filter_formula_type": "L'expression entrée pour la formule du filtre est invalide",
    "cwsx_different_nb_rows_tables": "Les tables d'entrée n'ont pas toutes le même nombre de lignes",
    "cwrx_invalid_number": "La valeur entrée pour la colonne numérique constante est invalide",
    "cwrx_invalid_string": "La valeur entrée pour la colonne de texte constante est invalide",
    "cwsx_no_primary_key": "Vous devez entrer des colonnes définissant une clé primaire",
    "cwrx_invalid_number": "Le nombre choisi n'est pas valide",
    "cwsx_history_start_not_integer": "Le début de l'historique doit être un entier",
    "cwsx_history_stop_not_integer": "La fin de l'historique doit être un entier",
    "cwrx_unicity_col_not_present": "L'une des colonnes d'unicité que vous avez choisie n'a pu être trouvée dans la table parent",
    "cwrx_discriminating_col_not_present": "L'une des colonnes discriminantes que vous avez choisie n'a pu être trouvée dans la table parent",
    "cwsx_parent_not_history_table": "La table parent doit être une table historique",
    "cwsx_filename_has_incorrect_characters": "Le nom de fichier choisi contient des caractères invalides ('/' or '\\' par exemple)",
    "cwsx_empty_filename": "Le nom de fichier ne doit pas être vide",
    "cwsx_relation_table_not_found": "Une des tables décrites dans les relations n'a pas pu être trouvée",
    "cwrx_period_id_not_valid": "La colonne de périodicité choisie ne semble pas au bon format",
    "cwsx_no_column_selected": "Vous n'avez choisi aucune colonne",
    "cwrx_invalid_date_format": "La date choisie ne respecte pas le format demandé",
    "cwrx_cannot_convert_to_date": "La date choisie n'est pas une date correcte",
    "cwrx_index_column_not_present": "Une des colonnes d'index n'a pas pu être trouvé dans une des tables",
    "cwrx_invalid_index": "Les colonnes d'index choisies ne forment pas un vrai index à cause de la duplication de certaines valeurs",
    "cwrx_period_id_column_not_present": "La colonne de périodicité n'a pas pu être trouvé dans une des tables",
    "cwrx_period_id_present_in_multiple_tables": "Un period_id ne peut pas être présent dans plus d'une table",
    "cwrx_too_high_index_in_filter": "Un indice du filtre est trop grand (plus grand que le nombre de lignes de la table parent",
    "cwrx_negative_index_in_filter": "Un indice du filtre est négatif",
    "cwrx_datetime_periodicity_col": "La colonne de périodicité doit être un nombre au format AAAAMM et non une colonne de Date",
    "cwrx_fe_different_size": "La valeur retournée pour la nouvelle colonne ne comporte pas le même nombre de lignes que la table d'entrée",
    "cwsx_duplicate_colname": "Plusieurs colonnes ayant le même nom ont été créées",
    "cwrx_fe_invalid_formula": "La formule entrée pour une des colonnes est invalide",
    "cwrx_fe_invalid_type": "Le type renvoyé par une des formules n'est pas accepté. Seuls les types numériques, date, et chaînes de caractères sont reconnus par Cosmo",
    "cwrx_column_only_header": "Une des colonnes semble n'avoir aucune donnée (seul le header semble présent)",
    "cwsx_start_ref_not_integer": "Le début de la période de référence doit être un entier",
    "cwsx_stop_ref_not_integer": "La fin de la période de référence doit être un entier",
    "cwsx_start_comp_not_integer": "The comparison period start must be an integer",
    "cwsx_stop_comp_not_integer": "The comparison period stop must be an integer",
    "cwrx_invalid_expression": "L'expression {expression} est incorrecte",
    "cwsx_no_table_satisfying_metavariable_conditions": "Aucune table satisfaisant les condition de metavariables demandées {required_metavariables} n'a pu être trouvée. Cet avertissement peut être ignoré s'il apparait dans une brique Dispatch partiellement configurée",
    "cwsx_no_file_satisfying_metavariable_conditions": "Aucun fichier satisfaisant les condition de metavariables demandées {required_metavariables} n'a pu être trouvée. Cet avertissement peut être ignoré s'il apparait dans une brique Fichier partiellement configurée",
    "cwsx_start_stop_incoherent": "La valeur start donnée est supérieure à la valeur stop",
    "cwsx_start_stop_ref_incoherent": "Le début de la période de référence est supérieur à sa fin",
    "cwsx_start_stop_comp_incoherent": "Le début de la période de comparaison est supérieur à sa fin",
    "cwsx_no_column_created": "Aucune nouvelle colonne n'a été créée",
    "cwrx_ast_eval_error": "Erreur survenue dans l'évaluateur du code : {error_message}",
    "cwrw_column_name_overridden": "Les colonnes suivantes sont initialement présentes dans la table d'entrée, leurs valeurs seront donc remplacées : {overridden_colnames}",
    "cwsw_start_greater_stop": "Le début de l'historique est supérieur à la fin de l'historique",
    "cwrw_columns_not_found": "Certaines colonnes sélectionnées ne sont pas présentes dans le fichier",
    "cwsw_duplicates_new_names": "Certains des nouveaux noms donnés pour les colonnes à renommer ou à copier sont identiques, ces colonnes vont donc être écrasées",
    "cwsx_no_dsn": "DSN manquant",
    "cwsx_no_query_string": "Requête SQL vide",
    "cwsx_invalid_batch_size": "La taille de batch doit être un nombre positif",
    "cwsw_start_ref_greater_stop_ref": "Le début de la période historique de référence est plus grand que la fin de la période historique de référence",
    "cwsw_ref_empty": "La période de référence entrée est vide",
    "cwsw_start_comp_greater_stop_comp": "Le début de la période historique de comparaison est plus grand que la fin de la période historique de comparaison",
    "cwsw_comp_empty": "La période de comparaison entrée est vide",
    "cwrx_apply_input_coercion": "Erreur dans la transformation de Table vers Json",
    "cwrx_apply_output_coercion": "Erreur dans la transformation de Json vers Table",
    "cwrx_apply_select_field": "Erreur dans l'opération 'Sélection d'un champ'",
    "cwrx_apply_insert_in_field": "Erreur dans l'opération 'Insertion dans un champ'",
    "cwrx_apply_object_to_table": "Erreur dans l'opération 'Transformation en tableau si objet'",
    "cwrx_apply_table_to_object": "Erreur dans l'opération 'Transformation d'un objet en tableau si observation unique'",
    "cwrx_invalid_manual_json": "L'objet Json défini manuellement est invalide",
    "cwxs_input_not_dict": "La formule entrée doit être un dictionnaire",
    "cwrw_column_distribution_has_changed": "La distribution de la colonne \"{column_name}\" a changé",
    "cwsx_unknwown_database_name": "La base de données \"{database_name}\" n'existe pas",
    "cwsx_database_name_has_duplicated": "Plusieurs bases de données ont le nom \"{database_name}\""
  }
}
</i18n>

<script>
import _ from 'lodash'
import { mapGetters, mapState } from 'vuex'
import * as Collections from 'typescript-collections'
import Vue from 'vue'

import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'

import {
  editing_component_from_name,
  definition_from_name,
  short_tooltip_description_from_name,
} from './workflow_common.js'
import chartColors from './chart_colors.js'
import {
  generic_update,
  show_debug,
  clean_brick_poid,
  get_user_category,
} from '@/api/subscriptions.js'
import {
  AutomlUniqueParentTable,
  FrozenSet,
  Dict,
  FrozenDict,
} from './object_model.js'
import {
  extended_dict_forEach,
  extended_dict_getValue,
  extended_dict_values,
  extended_dict_keys,
  dict_from_frozendict,
  extended_dict_items,
  project_auth_groups_enum,
} from '@/utils.js'

import { element_preview_type_from_name } from '@/components/workflow_common.js'

import ColumnstoreViewerMain from '@/components/columnstore_viewer_main.vue'
import JsonViewer from '@/components/json_viewer.vue'
import {
  subscription_mixin,
  metavariables_tracking_info_mixin,
  validation_buttons_bar_wrapper_mixin,
  project_mixin,
} from '@/components/mixin.js'
import ValidationButtonsBar from '@/components/validation_buttons_bar.vue'
import DescriptionEdition from '@/components/description_edition.vue'
import UnrollElement from '@/components/unroll_element.vue'
import MetavariablesSelector from '@/components/metavariables_selector.vue'
import GenericInAppScreen from '@/components/generic_in_app_screen.vue'

// *****************************************************************************

export default {
  name: 'GenericBrickWrapper',
  components: {
    ScaleLoader,
    ColumnstoreViewerMain,
    ValidationButtonsBar,
    DescriptionEdition,
    UnrollElement,
    MetavariablesSelector,
    GenericInAppScreen,
    JsonViewer,
  },
  mixins: [
    subscription_mixin,
    metavariables_tracking_info_mixin,
    validation_buttons_bar_wrapper_mixin,
    project_mixin,
  ],

  data() {
    return {
      scale_loader_properties: {
        loading: true,
        color: chartColors.blue,
        width: '64px',
        height: '64px',
      },
      answer_to_modal: false,
      description_name: {},
      has_been_validated: false,
      chosen_metavar: -1,
      // selected_metavars: [],
      has_unsaved_changes: false,
      selected_metavariables_dicts_poids: [],
      tables_previews_visibility: [],
      metavariables: [],
    }
  },
  metaInfo() {
    return {
      title: `Projet ${this.cur_project.name}`,
    }
  },
  computed: {
    splitted_path() {
      let fullpath = this.$route.fullPath
      let splitted_path = fullpath.split('/')
      return splitted_path
    },
    cancel_path() {
      let project_id = this.project_id
      return `/projects/${project_id}/workflow`
    },

    brick_id() {
      let n = this.splitted_path.length
      let res = this.splitted_path[n - 1]
      res = parseInt(res, 10)
      return res
    },

    cur_brick() {
      let res = (this.bricks_undeleted['bricks'] || {})[this.brick_id] || {}
      return res
    },

    changes_disabled() {
      let res = false
      if (this.cur_project.is_in_production) {
        res = true
      } else {
        let corresponding_project_rights = _.filter(
          this.automl_project_rights_undeleted_object.project_rights,
          {
            user_id: this.authenticated_user_id,
            project_id: this.project_id,
          }
        )

        if (
          !_.isEmpty(corresponding_project_rights) &&
          corresponding_project_rights[0].project_group_id ==
            project_auth_groups_enum.reader
        ) {
          res = true
        }
      }

      return res
    },

    brick_poids() {
      let res = extended_dict_values(this.cur_brick.last_poids_build_cache)
      return res
    },

    compute_failure_reasons() {
      let res = (this.cur_brick || {}).compute_failure_reasons || []
      return res
    },

    instantiation_failures_info() {
      let res = []
      let dict = this.cur_project.failed_poid_to_reason || {}
      let own_poids = this.brick_poids
      extended_dict_forEach(dict, (poid, failure_reason) => {
        if (_.includes(own_poids, poid)) {
          res.push({ poid, failure_reason })
        }
      })
      return res
    },

    partially_failed_poids() {
      return extended_dict_keys(this.cur_project.failed_poid_to_reason || {})
    },
    msg() {
      let brick = this.cur_brick
      const brick_name = brick.brick_name
      let res = short_tooltip_description_from_name(brick_name)
      return res
    },
    bricks_undeleted() {
      return this.automl_bricks_undeleted_object_per_project(this.project_id)
    },
    connectors_undeleted() {
      return this.automl_connectors_undeleted_object_per_project(
        this.project_id
      )
    },
    entry_tables() {
      let res = []
      let brick = this.cur_brick
      for (let connector_id of this.connectors_undeleted['lists']) {
        let connector = this.connectors_undeleted['connectors'][connector_id]
        if (connector.to_brick_uid === brick.uid) {
          let cur_name = this.bricks_undeleted['bricks'][
            connector.from_brick_uid
          ].name
          res.push(cur_name)
        }
      }
      return res
    },
    has_connector_problem() {
      let brick = this.cur_brick
      let res = false
      if (brick instanceof AutomlUniqueParentTable) {
        res = brick.has_connector_problem
      }
      return res
    },

    progress_percentage() {
      let res = this.fetch_brick_progress('brick_progress', this.brick_id)
      return res
    },
    computation_time() {
      let res = this.fetch_brick_computation_time(
        'brick_computation_time',
        this.brick_id
      )
      return res
    },
    brick_semantic_warnings() {
      let res = this.cur_brick.semantic_warnings
      return res
    },

    brick_runtime_warnings() {
      const category_and_arguments_list = _.map(this.brick_poids, poid => [
        'poid_tracking_info',
        poid,
      ])
      const tracking_infos = this.fetch_many(
        'brick_runtime_warnings',
        category_and_arguments_list
      )
      let res = []
      for (const tracking_info of tracking_infos) {
        const poid_warnings = (tracking_info || {}).warnings || []
        res = _.concat(res, poid_warnings)
      }

      // N.B : Use of stringify because in javascript two arrays can never be
      // equal (even if they contain the same things)
      res = _.uniq(res, function(x) {
        return JSON.stringify(x)
      })
      return res
    },
    current_component_name() {
      let brick = this.cur_brick
      let component = undefined
      if (!_.isUndefined(brick)) {
        let type = brick.brick_name
        component = editing_component_from_name(type)
      }
      return component
    },

    element_preview_type() {
      let brick = this.cur_brick
      let component = undefined
      if (!_.isUndefined(brick)) {
        let type = brick.brick_name
        component = element_preview_type_from_name(type)
      }
      return component
    },
    // element_preview_title() {
    //   console.log('In element preview title', this.element_preview_type)
    //   if (this.element_preview_type === '') {
    //   }
    // },
    can_show() {
      let res = !_.isUndefined(this.current_component_name)
      return res
    },
    // semantic_and_runtime_exceptions() {
    //   let res = []
    //   let variant = 'danger'
    //   for (let {
    //     poid,
    //     failure_reason: [is_translatable, msg],
    //   } of this.instantiation_failures_info) {
    //     res.push({
    //       variant,
    //       is_translatable,
    //       msg,
    //     })
    //   }
    //   variant = 'warning'
    //   for (let [metavar_dict, [is_translatable, msg]] of extended_dict_items(
    //     this.compute_failure_reasons
    //   )) {
    //     res.push({
    //       variant,
    //       is_translatable,
    //       msg,
    //     })
    //   }
    //   const fields = ['variant', 'is_translatable', 'msg']
    //   res = _.orderBy(res, fields, ['desc', 'asc', 'asc'])
    //   res = _.sortedUniqBy(res, fields)
    //   return res
    // },

    semantic_and_runtime_exceptions() {
      let res = []
      let variant = 'danger'
      for (let {
        poid,
        failure_reason: [is_translatable, msg],
      } of this.instantiation_failures_info) {
        res.push({
          variant,
          is_translatable,
          msg,
        })
      }

      variant = 'warning'
      for (let [metavar_dict, [is_translatable, msg]] of extended_dict_items(
        this.compute_failure_reasons
      )) {
        res.push({
          variant,
          is_translatable,
          msg,
        })
      }
      const fields = ['variant', 'is_translatable', 'msg']
      res = _.orderBy(res, fields, ['desc', 'asc', 'asc'])
      res = _.sortedUniqBy(res, fields)
      return res
    },

    selected_metavariables_dicts_poids_instantiation_status() {
      let res = _.map(this.selected_metavariables_dicts_poids, (poid, index) =>
        this.fetch_poid_status(
          `selected_metavariables_dicts_poids_instantiation_status_${index}`,
          poid
        )
      )
      return res
    },

    ...mapState(['platform_status']),
    ...mapGetters([
      'automl_projects_undeleted_object',
      'automl_bricks_undeleted_object_per_project',
      'automl_connectors_undeleted_object_per_project',
      'automl_project_rights_undeleted_object',
      'authenticated_user_id',
    ]),
  },
  watch: {
    cur_brick: {
      immediate: true,
      handler(new_val) {
        new_val = new_val || {}
        this.description_name = {
          name: new_val.name,
          description: new_val.description,
        }
        this.chosen_metavar = -1
      },
    },

    selected_metavariables_dicts_poids: {
      immediate: true,
      handler(nv, ov) {
        if (!_.isEqual(nv, ov)) {
          this.tables_previews_visibility = _.map(nv, false)
        }
      },
    },
  },

  beforeMount() {
    this.dict_from_frozendict = dict_from_frozendict
    this.fetch_collections([
      'bricks',
      'connectors',
      'projects',
      'users',
      'project_rights',
    ])
  },
  beforeRouteLeave(to, from, next) {
    this.$refs.validation_buttons_bar.check_unsaved_changes(next)
  },
  methods: {
    async recompute_metavariables_dict(poid) {
      await clean_brick_poid(this.project_id, this.brick_id, poid)
    },

    // element_preview_title(poid) {
    //   let res = this.no_table_preview_bricks.includes(
    //     this.current_component_name
    //   )
    //     ? this.$t('json_preview')
    //     : this.$t('table_preview')

    //   res += ' '
    //   res += this.stringified_dict(poid)
    //   // let stringified_metavariables_dict = this.available_metavariables_dicts[
    //   //   poid
    //   // ]
    //   // stringified_metavariables_dict = JSON.stringify(
    //   //   stringified_metavariables_dict
    //   // )
    //   // res += stringified_metavariables_dict
    //   return res
    // },
    element_preview_title(poid) {
      let res =
        this.element_preview_type === 'JsonViewer'
          ? this.$t('json_preview')
          : this.$t('table_preview')

      res += ' ' + this.stringified_dict(poid)
      return res
    },

    async save_function() {
      let data = this.$refs.component.adapted_data
      this.$refs.description_edition.saved()
      await generic_update(this.project_id, data)
    },
    presymbolclasses() {
      let brick = this.cur_brick
      const brick_name = brick.brick_name
      const brick_info = definition_from_name(brick_name) || {}
      let res = _.join(brick_info.back_classes || '', ' ')
      return res
    },
    symbolclasses() {
      let brick = this.cur_brick
      const brick_name = brick.brick_name
      const brick_info = definition_from_name(brick_name) || {}
      let res = _.join(brick_info.front_classes || '', ' ')
      return res
    },
    symbolholderclasses() {
      let res = ['brickeditionsymbolholderdefault', 'd-inline-block']
      return res
    },

    on_save_description_edition() {
      this.$refs.description_edition.saved()
    },

    metavariable_click() {
      this.$refs.metac.hide(false)
    },
    click_show_debug() {
      let commands_list = ['show_debug']
      show_debug(commands_list)
    },
    click_disconnect_backend_socketio() {
      let commands_list = ['disconnect_backend']
      show_debug(commands_list)
    },
    click_disconnect_aiplatform_from_backend() {
      let commands_list = ['disconnect_aiplatform']
      show_debug(commands_list)
    },
    update_has_unsaved_changes(nv) {
      this.has_unsaved_changes = nv
    },
    toggled_table_visibility(index, value) {
      Vue.set(this.tables_previews_visibility, index, value)
    },
  },
}
</script>
